<div
  [@condense]="menuState"
  (@condense.done)="animationDone($event)"
  class="condense-wrapper"
>
  <ng-content></ng-content>
</div>
